import { Box, Stack, Typography } from "@mui/material";
import React from "react";

/**
 * Shared chrome for the Security & Logs pages: the title row (matching the
 * `mainTitle` / `page-title` treatment used across the admin listing pages) and
 * the white rounded card the existing list pages wrap their tables in.
 */
export const PageHeader = ({ title, subtitle, actions }) => (
    <Stack
        className="mainTitle flex-wrap"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ minHeight: "42px", padding: "0px 16px", gap: 2 }}
    >
        <Box>
            <Typography className="page-title" variant="h1">{title}</Typography>
            {subtitle && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    {subtitle}
                </Typography>
            )}
        </Box>
        {actions && <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">{actions}</Stack>}
    </Stack>
);

export const Card = ({ children, sx = {} }) => (
    <Box
        sx={{
            backgroundColor: "#fff",
            transition: "all .5s ease-in-out",
            position: "relative",
            border: "1px solid rgba(170, 170, 170, 0.3)",
            borderRadius: "12px",
            boxShadow: "0px 5px 5px 0px rgba(82, 63, 105, 0.05)",
            overflow: "hidden",
            ...sx,
        }}
    >
        {children}
    </Box>
);

/** A single headline number. `tone` tints the value for at-a-glance severity. */
export const StatTile = ({ label, value, hint, tone = "default" }) => {
    const color =
        tone === "error" ? "#d32f2f" :
            tone === "warning" ? "#ed6c02" :
                tone === "success" ? "#2e7d32" : "#1c1c1c";
    return (
        <Card sx={{ flex: "1 1 180px", minWidth: 180, padding: "16px 20px" }}>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", letterSpacing: 0.6 }}>
                {label}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color, mt: 0.5, lineHeight: 1.2 }}>
                {value}
            </Typography>
            {hint && (
                <Typography variant="caption" color="text.secondary">{hint}</Typography>
            )}
        </Card>
    );
};

export const PageBody = ({ children }) => (
    <Box sx={{ padding: "0px 16px", display: "flex", flexDirection: "column", gap: 2 }}>
        {children}
    </Box>
);
